import { render, staticRenderFns } from "./PaymentMethodSelector.vue?vue&type=template&id=634dcd8e&scoped=true"
import script from "./PaymentMethodSelector.vue?vue&type=script&lang=js"
export * from "./PaymentMethodSelector.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodSelector.vue?vue&type=style&index=0&id=634dcd8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634dcd8e",
  null
  
)

export default component.exports